import React from 'react'
import PropTypes from 'prop-types'
import { consentSettingLabel, consentSettingName } from '@src/services/consentSettings'

/**
 * The consent settings the company changed since the batch was uploaded, as
 * the backend compared them (consent_changes: [{ key, from, to }], on the
 * batch detail and on a refused Process). One line per setting.
 */
export default function ConsentChanges({ changes }) {
  if (!changes?.length) return null
  return (
    <span className="flex flex-col">
      {changes.map(({ key, from, to }) => (
        <span key={key} className="block">
          {consentSettingName(key)}: {consentSettingLabel(key, from)} → {consentSettingLabel(key, to)}
        </span>
      ))}
    </span>
  )
}

ConsentChanges.propTypes = {
  changes: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, from: PropTypes.any, to: PropTypes.any })),
}

/** Whether the e-KTP setting is among the changes: applying them may drop the batch's e-KTP data and photos. */
export const ektpChanged = (changes) => (changes || []).some((change) => change.key === 'ektp_upload_process')
